// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1zPd6","dragIcon":"SortableItem_dragIcon__2zayB","disabled":"SortableItem_disabled__1Ozyo"};